import React, { useState } from 'react';
import axios from 'axios';

axios.defaults.withCredentials = true;

export default function PosManagePage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);
    setError('');

    try {
      const form = new URLSearchParams();
      form.append('username', username);
      form.append('password', password);

      // 주의: Flask 라우트와 동일하게 설정 (/api가 붙어있는지 확인하세요)
      const res = await axios.post('/api/pos/manage', form, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      });

      // 서버에서 보낸 success 값 확인
      if (res.data?.success) {
        window.location.href = res.data.redirect_url || '/pos';
      } else {
        setError(res.data?.message || '로그인 실패');
      }
    } catch (err) {
      // 400, 401, 500 등 에러 발생 시 처리
      const msg = err.response?.data?.message || '로그인 중 오류가 발생했습니다.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        body{ font-family:'Noto Sans KR',sans-serif; }
        .pos-login-page{ min-height:100vh; background:#6c757d; }
        .modal-signin{ max-width:420px; }
        .modal-card{ background:#fff; border-radius:.25rem; box-shadow:0 .5rem 1rem rgba(0,0,0,.15); }
      `}</style>

      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
      <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+KR&family=Righteous&display=swap" rel="stylesheet" />

      <div className="pos-login-page d-flex align-items-center justify-content-center py-5">
        <div className="modal-signin w-100 px-3">
          <div className="modal-card overflow-hidden">
            <div className="p-5 pb-4 border-bottom-0">
              <h1 className="fw-bold mb-0 fs-2">포스 로그인</h1>
            </div>

            <div className="p-5 pt-0">
              <form onSubmit={handleSubmit}>
                {error ? <div className="alert alert-danger">{error}</div> : null}

                <div className="form-floating mb-3">
                  <input
                    type="text"
                    className="form-control rounded-3"
                    name="username"
                    id="floatingInput"
                    placeholder="Id"
                    required
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                  <label htmlFor="floatingInput">아이디</label>
                </div>

                <div className="form-floating mb-3">
                  <input
                    type="password"
                    className="form-control rounded-3"
                    name="password"
                    id="floatingPassword"
                    placeholder="Password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <label htmlFor="floatingPassword">패스워드</label>
                </div>

                <button className="w-100 mb-2 btn btn-lg rounded-1 btn-primary" type="submit" disabled={loading}>
                  {loading ? '로그인 중...' : '로그인'}
                </button>

                <small className="text-muted"></small>
                <p className="mt-5 mb-3 text-muted">&copy; 2025</p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
